<template>
    <form class="contact--form" @submit.prevent="submit" enctype="multipart/form-data">
        <div class="heading-border contact-form--title" v-if="ContactPage">Send us a message</div>
        <div class="contact--form-row">
            <div class="contact--form-col">
                <label label="name" class="input-block">
                    <span class="input-block--label">Name</span>
                    <input v-model="Form.name"  type="text" id="name" placeholder="Your Name" maxlength="255" required="required">
                    <span class="error-message">{{ error.name }}</span>
                </label>
                <label label="state" class="input-block">
                    <span class="input-block--label">State</span>
                    <select v-model="Form.state" label="State" type="select" id="state">
                        <option selected="" v-for="state in states" v-bind:value="state.id" :key="state.id">
                            {{ state.name }}
                        </option>
                    </select>
                    <span class="error-message">{{ error.state }}</span>
                </label>
            </div>
            <div class="contact--form-col">
                <label label="email" class="input-block">
                    <span class="input-block--label"></span>
                    <input v-model="Form.email" type="email" id="email" placeholder="Email" maxlength="255" required="required">
                    <span class="error-message">{{ error.email }}</span>
                </label>
                <label label="phone" class="input-block">
                    <span class="input-block--label"></span>
                    <input v-model="Form.phone" type="text" id="phone" placeholder="Your Phone Number" maxlength="255" required="required">
                    <span class="error-message">{{ error.phone }}</span>
                </label>
            </div>
        </div>
        <label label="message" class="input-block mt-30">
            <span class="input-block--label">How may we help you?</span>
            <textarea class="mt-30" v-model="Form.message" type="textarea" id="message" required="required"></textarea>
            <span class="error-message">{{ error.message }}</span>
        </label>
        <div class="contact--form-bottom">
            <button type="submit" class="btn btn-arrow btn-default contact--form-submit" :disabled="loading">
                Send
                <svg class="svg-sprite-icon svg-sprite-unstyled icon-arrow-right-long">
                <use xlink:href="/img/svg/symbol/symbol_unstyled.svg#i-arrow-right-long"></use>
                </svg>
            </button>
            <template v-if="!ContactPage">
                <div class="contact--note" v-if="success">Successfully Sent</div>
                <div class="contact--form-or">or</div>
                <div class="contact--form-call">
                    <div class="contact--form-call-title">call us</div>
                    <a href="tel:+19294935965" class="contact--form-call-val">(929) 493 5965</a>
                </div>
            </template>
        </div>
    </form>
</template>

<script>
export default {
    props: {
        url: String,
        StatesUrl: String,
        ContactPage: {
            type: Boolean,
            required: false
        }
    },
    data: () => ({
        states: [],
        Form: {
            name: '',
            email: '',
            state: '',
            phone: '',
            message: '',
        },
        error: {

        },
        loading: false,
        success: false
    }),
    methods: {
        fetch() {
            this.loading = true;
            axios.get(this.StatesUrl).then((res) => {
                this.states = res.data;
                this.loading = false;
            });
        },
        submit() {
            this.loading = true;
            let formData = this.Form;
            axios.post(this.url, formData)
            .then((res) => {
                this.error = '';
                if(res.data.Errors) {
                    this.error = res.data.Errors;
                    console.log(res.data.Errors);
                    var errors = res.data.Errors;
                    var errormessage = '';
                    Object.keys(errors).forEach(function(key) {
                        errormessage += errors[key] + '<br />';
                    });
                    console.log(errormessage);
                    this.loading = false;
                }
                // let data = res.data;
                // this.notify('Sended', 2000, 'success');
                if(res.data.success) {
                    this.loading = false;
                    this.success = true;
                }
                this.loading = false;
                // this.isModalVisible = false;
            }).catch(err => {
                this.loading = false;
                console.log(err.message);
            });
        },
    },
    mounted() {
        this.fetch();
    },
}
</script>

<style>
    label {
        font-weight: 400;
    }
</style>
